module.exports = __webpack_public_path__ + "img/72e788db5645b0a8151441a21c5fc2e.80dd7287.jpg";